export interface ShareWebParams {
  domain: string;
  moduleKey: string;
  shareCode: string;
  imageId: string;
  utm_campaign?: string;
}

function isMobile() {
  if (typeof window === "undefined") {
    return false;
  }

  return /(android|iphone|ipad|mobile)/i.test(navigator.userAgent);
}

export const getShareUrl = ({
  domain,
  moduleKey,
  shareCode,
  imageId,
  utm_campaign,
}: ShareWebParams) => {
  if (typeof window === "undefined") {
    return "";
  }

  const origin = `${domain.replace(".ai", ".tech")}/intents`;

  let share = `${origin}?t=${moduleKey}${shareCode}&p=${imageId}`;
  if (utm_campaign) {
    share += `&utm_campaign=${utm_campaign}`;
  }

  return share;
};

export const getShareDownloadUrl = ({
  domain,
  moduleKey,
  shareCode,
  imageId,
}: ShareWebParams) => {
  if (typeof window === "undefined") {
    return "";
  }

  const origin = `${domain.replace(".ai", ".tech")}/intents/download`;

  const share = `${origin}?t=${moduleKey}${shareCode}&p=${imageId}`;
  console.log(share);

  return share;
};

function encodeShareUrl(link: string) {
  return encodeURIComponent(link);
}

function handleShare(url: string) {
  if (typeof window === "undefined") {
    return;
  }

  const params = `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no`;
  return window.open(url, "", params);
}

export const shareToFacebook = (link: string) => {
  const encodeUrl = encodeShareUrl(link);

  const directUrl = `http://www.facebook.com/sharer/sharer.php?u=${encodeUrl}&ref=plugin&src=like&kid_directed_site=0`;
  handleShare(directUrl);
};

export const shareToTwitter = (link: string, text: string) => {
  const encodeUrl = encodeShareUrl(link);

  const directUrl = `https://twitter.com/intent/tweet?url=${encodeUrl}&text=${text}`;
  handleShare(directUrl);
};

export const shareToTelegram = (link: string, text: string) => {
  const encodeUrl = encodeShareUrl(link);
  const directUrl = `https://t.me/share/?url=${encodeUrl}&text=${text}`;
  handleShare(directUrl);
};

export const shareToWhatsapp = (link: string) => {
  const prefix = isMobile() ? "api" : "web";
  const encodeUrl = encodeShareUrl(link);
  const directUrl = `https://${prefix}.whatsapp.com/send?text=${encodeUrl}`;
  handleShare(directUrl);
};

export const shareToMessager = (link: string) => {
  const encodeUrl = encodeShareUrl(link);
  const directUrl = `fb-messenger://share?link=${encodeUrl}`;
  handleShare(directUrl);
};

export const shareToLine = (link: string) => {
  const encodeUrl = encodeShareUrl(link);
  const directUrl = `https://social-plugins.line.me/lineit/share?url=${encodeUrl}`;
  handleShare(directUrl);
};

export const shareToSnapchat = (link: string) => {
  const encodeUrl = encodeShareUrl(link);
  const directUrl = `https://snapchat.com/scan?attachmentUrl=${encodeUrl}`;
  handleShare(directUrl);
};

const ShareWeb = {
  shareToFacebook,
  shareToTwitter,
  shareToTelegram,
  shareToWhatsapp,
  shareToMessager,
  shareToLine,
  shareToSnapchat,
};

export default ShareWeb;
